import React from 'react'
import { Link } from "react-router-dom";
import WhatsappIcon from '../../pages/WhatsappIcon';
import PopUp from '../../pages/PopUp';


const Footer = () => {
  return (
    <>

      <footer className="main-footer-royal dark-section">
        <div className="container">
          <div className="row">
            <div className="col-xl-3">
              {/* About Footer Start */}
              <div className="about-footer-royal">
                {/* Footer Logo Start */}
                <div className="footer-logo-royal">
                  <img src="./assets/solar/solarwesta_1.webp" alt />
                </div>
                <div className="footer-contact-info-list-royal">
                  {/* Footer Contact Info Start */}
                  <div className="footer-contact-info-royal">
                    <div className="icon-box">
                      <img src="./assets/images/icon-phone-white.svg" alt />
                    </div>
                    <div className="footer-contact-info-content-royal">
                      <p>Phone Number</p>
                      <h2><a href="tel:+91 9516839231">+91 9516839231</a></h2>
                    </div>
                  </div>
                  {/* Footer Contact Info End */}
                </div>
                {/* Footer Contact Info List End */}
              </div>
              {/* About Footer End */}
            </div>
            <div className="col-xl-9">
              {/* Footer Links Box Start */}
              <div className="footer-links-box-royal">
                {/* Footer Links Start */}
                <div className="footer-links-royal">
                  <h2>Quick Links</h2>
                  <ul>
                    <li><Link  to="/">Home</Link ></li>
                    <li><Link  to="/about">About Us</Link ></li>
                    <li><Link  to="/contact-us">Contact Us</Link ></li>
                    <li><Link  to="/gallery">Our Gallery</Link ></li>
                    <li><Link  to="/blog">Blog & Updates</Link ></li>
                  </ul>
                </div>
                {/* Footer Links End */}
                {/* Footer Links Start */}
                <div className="footer-links-royal">
                  <h2>Our Services</h2>
                  <ul>
                    <li><Link to="/EV-charging-solution">EV Charging Solution</Link></li>
                    <li><Link to="/on-grid-off-grid-solar">On-Grid & Off-Grid Solar</Link></li>
                    <li><Link to="/hybrid-solar-power-plant">Hybrid Solar Power Plant</Link></li>
                    <li><Link to="/solar-water-pump-solution">Solar Water Pump Solution</Link></li>
                    <li><Link to="/solar-electrical-installation">Solar & Electrical Installation</Link></li>
                  </ul>
                </div>
                {/* Footer Links End */}
                {/* Footer Newsletter Box Start */}
                <div className="footer-links-royal footer-newsletter-box-royal">
                  <h2>Google Map</h2>

                  <div className="mapouter"><div className="gmap_canvas"><iframe className="gmap_iframe" width="100%" frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?width=600&height=200&hl=en&q=Solar World Enterprises Satna&t=&z=14&ie=UTF8&iwloc=B&output=embed" /><a href="https://embed-googlemap.com">embed google maps in website</a></div><style dangerouslySetInnerHTML={{ __html: ".mapouter{position:relative;text-align:right;width:100%;height:200px;}.gmap_canvas {overflow:hidden;background:none!important;width:100%;height:200px;}.gmap_iframe {height:200px!important;}" }} /></div>


                </div>
                {/* Footer Newsletter Box End */}
              </div>
              {/* Footer Links Box End */}
            </div>
          </div>
        </div>
        {/* Footer Copyright Start */}
        <div className="footer-copyright-royal">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                {/* Footer Copyright Text Start */}
                <div className="footer-copyright-text-royal">
                  <p>2026 © Solar Westa | <a style={{color:"white"}} href="tel:+91 8982471422">Designed by Web solution & digital marketing</a> </p>
                </div>
                {/* Footer Copyright Text End */}
              </div>
            </div>
          </div>
        </div>
        {/* Footer Copyright End */}
      </footer>
      {/* <PopUp /> */}
      <WhatsappIcon />



    </>
  )
}

export default Footer